import { isSupportedCurrency, SupportedCurrencies } from './price-table'

// Country is represented by ISO 3166-1 alpha-2
// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2

const countryCurrencyMap: { [key: string]: string } = {
    AF: 'USD',
    AL: 'USD',
    DZ: 'DZD',
    AS: 'USD',
    AD: 'EUR',
    AO: 'USD',
    AI: 'USD',
    AQ: 'USD',
    AG: 'XCD',
    AR: 'ARS',
    AM: 'AMD',
    AW: 'AWG',
    AC: 'USD',
    AU: 'AUD',
    AT: 'EUR',
    AZ: 'USD',
    BS: 'USD',
    BH: 'BHD',
    BD: 'BDT',
    BB: 'BBD',
    BY: 'USD',
    BE: 'EUR',
    BZ: 'BZD',
    BJ: 'USD',
    BM: 'USD',
    BT: 'BTN',
    BO: 'USD',
    BA: 'USD',
    BW: 'BWP',
    BV: 'USD',
    BR: 'BRL',
    IO: 'USD',
    BN: 'BND',
    BG: 'BGN',
    BF: 'USD',
    BI: 'USD',
    KH: 'USD',
    CM: 'XAF',
    CA: 'CAD',
    CV: 'USD',
    KY: 'USD',
    CF: 'USD',
    TD: 'USD',
    CL: 'USD',
    CN: 'CNY',
    CX: 'USD',
    CC: 'USD',
    CO: 'COP',
    KM: 'USD',
    CG: 'USD',
    CD: 'USD',
    CK: 'NZD',
    CR: 'CRC',
    CI: 'XOF',
    HR: 'HRK',
    CU: 'USD',
    CY: 'EUR',
    CZ: 'CZK',
    DK: 'DKK',
    DJ: 'USD',
    DM: 'XCD',
    DO: 'DOP',
    TP: 'USD',
    EC: 'USD',
    EG: 'EGP',
    SV: 'USD',
    GQ: 'USD',
    ER: 'ERN',
    EE: 'EUR',
    ET: 'ETB',
    FK: 'FKP',
    FO: 'DKK',
    FJ: 'FJD',
    FI: 'EUR',
    FR: 'EUR',
    GF: 'EUR',
    PF: 'USD',
    TF: 'EUR',
    GA: 'USD',
    GM: 'GMD',
    GE: 'USD',
    DE: 'EUR',
    GH: 'GHC',
    GI: 'GBP',
    GR: 'EUR',
    GL: 'DKK',
    GD: 'XCD',
    GP: 'USD',
    GU: 'USD',
    GT: 'GTQ',
    GG: 'GBP',
    GN: 'USD',
    GW: 'USD',
    GY: 'GYD',
    HT: 'USD',
    HM: 'USD',
    HN: 'HNL',
    HK: 'HKD',
    HU: 'HUF',
    IS: 'ISK',
    IN: 'INR',
    ID: 'IDR',
    IR: 'IRR',
    IQ: 'USD',
    IE: 'EUR',
    IM: 'GBP',
    IL: 'ILS',
    IT: 'EUR',
    JM: 'JMD',
    JP: 'JPY',
    JE: 'GBP',
    JO: 'JOD',
    KZ: 'USD',
    KE: 'KES',
    KI: 'USD',
    KP: 'USD',
    KR: 'USD',
    KW: 'KWD',
    KG: 'USD',
    LA: 'USD',
    LV: 'USD',
    LB: 'LBP',
    LS: 'ZAR',
    LR: 'USD',
    LY: 'USD',
    LI: 'CHF',
    LT: 'USD',
    LU: 'EUR',
    MO: 'MOP',
    MK: 'MKD',
    MG: 'USD',
    MW: 'MWK',
    MY: 'MYR',
    MV: 'USD',
    ML: 'USD',
    MT: 'EUR',
    MH: 'USD',
    MQ: 'EUR',
    MR: 'USD',
    MU: 'MUR',
    YT: 'EUR',
    MX: 'MXN',
    FM: 'USD',
    MD: 'USD',
    MC: 'EUR',
    MN: 'USD',
    MS: 'XCD',
    MA: 'MAD',
    MZ: 'USD',
    MM: 'USD',
    NA: 'NAD',
    NR: 'AUD',
    NP: 'NPR',
    NL: 'EUR',
    AN: 'ANG',
    NC: 'USD',
    NZ: 'NZD',
    NI: 'NIO',
    NE: 'USD',
    NG: 'NGN',
    NU: 'NZD',
    NF: 'AUD',
    MP: 'USD',
    NO: 'NOK',
    OM: 'OMR',
    PK: 'PKR',
    PW: 'USD',
    PS: 'USD',
    PA: 'PAB',
    PG: 'PGK',
    PY: 'PYG',
    PE: 'USD',
    PH: 'PHP',
    PN: 'USD',
    PL: 'PLN',
    PT: 'EUR',
    PR: 'USD',
    QA: 'QAR',
    RE: 'USD',
    RO: 'USD',
    RU: 'USD',
    RW: 'USD',
    KN: 'XCD',
    LC: 'XCD',
    VC: 'XCD',
    WS: 'WST',
    SM: 'EUR',
    ST: 'USD',
    SA: 'SAR',
    SN: 'USD',
    CS: 'EUR',
    SC: 'USD',
    SL: 'USD',
    SG: 'SGD',
    SK: 'USD',
    SI: 'EUR',
    SB: 'SBD',
    SO: 'USD',
    ZA: 'ZAR',
    GS: 'USD',
    ES: 'EUR',
    LK: 'LKR',
    SH: 'USD',
    PM: 'USD',
    SD: 'USD',
    SR: 'USD',
    SJ: 'USD',
    SZ: 'SZL',
    SE: 'SEK',
    CH: 'CHF',
    SY: 'SYP',
    TW: 'TWD',
    TJ: 'USD',
    TZ: 'TZS',
    TH: 'THB',
    TG: 'USD',
    TK: 'USD',
    TO: 'TOP',
    TT: 'TTD',
    TN: 'TND',
    TR: 'USD',
    TM: 'USD',
    TC: 'USD',
    TV: 'USD',
    UM: 'USD',
    UG: 'UGX',
    UA: 'USD',
    AE: 'AED',
    UK: 'GBP',
    US: 'USD',
    UY: 'USD',
    UZ: 'USD',
    VU: 'VUV',
    VA: 'USD',
    VE: 'VEB',
    VN: 'USD',
    VG: 'USD',
    VI: 'USD',
    WF: 'USD',
    EH: 'USD',
    YE: 'USD',
    ZM: 'USD',
    ZW: 'USD',
} as const

export function getCurrencyByCountry(country = 'US'): SupportedCurrencies {
    const currency = countryCurrencyMap[country] ?? 'USD'
    return isSupportedCurrency(currency) ? (currency as SupportedCurrencies) : 'USD'
}
